var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/es6.object.define-property.js
// module id = 115
// module chunks = 1 2 3 6 7 8 10 11 12 13 14 16 17 19 21 22 23 25 26 27 28 29 31 32 33 34 35 36 37 38 40 41 43 45 46 49 51